import THIALVARE_EXT_1 from "./THIALVARE_EXT_1";
export default {
  THIALVARE_EXT_1,
};
